export const coreValues = () => {
    const coreValuesEl = document.querySelector('.core-values');
    if (!coreValuesEl) return;
    
    console.log('Core Values initialized'); // Debug logging
    
    // Set up event listeners
    const buttons = coreValuesEl.querySelectorAll('.core-values__expand-button');
    console.log('Found buttons:', buttons.length); // Debug logging
    
    buttons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent default button behavior
            e.stopPropagation(); // Stop event bubbling
            
            console.log('Button clicked'); // Debug logging
            
            const btn = e.currentTarget as HTMLButtonElement;
            const article = btn.closest('.core-values__value');
            const contentId = btn.getAttribute('aria-controls');
            const content = document.getElementById(contentId || '');
            const isExpanded = btn.getAttribute('aria-expanded') === 'true';
            
            console.log('Content element:', content, 'isExpanded:', isExpanded); // Debug logging
            
            // Close all other cards first
            coreValuesEl.querySelectorAll('.core-values__expand-button[aria-expanded="true"]').forEach(otherBtn => {
                if (otherBtn !== btn) {
                    otherBtn.setAttribute('aria-expanded', 'false');
                    const otherContentId = otherBtn.getAttribute('aria-controls');
                    const otherContent = document.getElementById(otherContentId || '');
                    const otherArticle = otherBtn.closest('.core-values__value');
                    if (otherContent) otherContent.setAttribute('aria-hidden', 'true');
                    if (otherArticle) otherArticle.classList.remove('core-values__value--active');
                }
            });
            
            // Toggle state
            if (isExpanded) {
                btn.setAttribute('aria-expanded', 'false');
                if (content) content.setAttribute('aria-hidden', 'true');
                if (article) article.classList.remove('core-values__value--active');
                console.log('Card collapsed'); // Debug logging
            } else {
                btn.setAttribute('aria-expanded', 'true');
                if (content) content.setAttribute('aria-hidden', 'false');
                if (article) article.classList.add('core-values__value--active');
                console.log('Card expanded'); // Debug logging
            }
        });
    });
    
    // Add this to the coreValues function
    coreValuesEl.querySelectorAll('.core-values__value').forEach(card => {
        card.addEventListener('click', (e) => {
            // Only handle clicks on the card itself, not its children
            if (e.target === card || e.target === card.querySelector('picture') || e.target === card.querySelector('img')) {
                const button = card.querySelector('.core-values__expand-button') as HTMLButtonElement;
                if (button) {
                    button.click();
                }
            }
        });
    });
    
    // Stop click events on content from bubbling to article
    coreValuesEl.querySelectorAll('.core-values__content').forEach(content => {
        content.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });
    
    // Handle Escape key to close expanded cards
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        
        const expandedButtons = coreValuesEl.querySelectorAll('.core-values__expand-button[aria-expanded="true"]');
        if (expandedButtons.length === 0) return;
        
        expandedButtons.forEach(btn => {
            (btn as HTMLButtonElement).click();
        });
    });
};